(function () {
  const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  const DAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

  function daysFromNow(n) {
    const d = new Date();
    d.setHours(12, 0, 0, 0);
    d.setDate(d.getDate() + n);
    return d;
  }

  function shortDate(d) {
    return MONTHS[d.getMonth()] + ' ' + d.getDate();
  }

  function longDate(d) {
    return DAYS[d.getDay()] + ', ' + shortDate(d);
  }

  function dateRange(a, b) {
    if (a.getTime() === b.getTime()) return shortDate(a);
    if (a.getMonth() === b.getMonth()) return shortDate(a) + ' to ' + b.getDate();
    return shortDate(a) + ' to ' + shortDate(b);
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  }

  /* ---------- Delivery dates ---------- */

  function initDelivery(root) {
    root.querySelectorAll('[data-ell-delivery]').forEach((el) => {
      const min = daysFromNow(parseInt(el.dataset.min, 10) || 0);
      const max = daysFromNow(parseInt(el.dataset.max, 10) || 0);
      const shipMin = daysFromNow(parseInt(el.dataset.shipMin, 10) || 0);
      const shipMax = daysFromNow(parseInt(el.dataset.shipMax, 10) || 0);

      const line = el.querySelector('[data-ell-delivery-line]');
      if (line && el.dataset.line) {
        line.innerHTML = escapeHtml(el.dataset.line)
          .replace('[from]', '<strong>' + longDate(min) + '</strong>')
          .replace('[to]', '<strong>' + longDate(max) + '</strong>');
      }
      const ship = el.querySelector('[data-ell-delivery-date="ship"]');
      if (ship) ship.textContent = dateRange(shipMin, shipMax);
      const arrive = el.querySelector('[data-ell-delivery-date="arrive"]');
      if (arrive) arrive.textContent = dateRange(min, max);
    });
  }

  /* ---------- Reviews ---------- */

  const ICONS = {
    verified:
      '<svg class="ell-icon" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2.8l2.3 1.7 2.9-.1.9 2.7 2.3 1.7-.9 2.7.9 2.7-2.3 1.7-.9 2.7-2.9-.1L12 20.9l-2.3-1.7-2.9.1-.9-2.7-2.3-1.7.9-2.7-.9-2.7 2.3-1.7.9-2.7 2.9.1L12 2.8z"/><path d="M8.8 12l2.2 2.2 4.2-4.4"/></svg>',
    thumb:
      '<svg class="ell-icon" viewBox="0 0 24 24" aria-hidden="true"><path d="M8 10.5v9H5v-9zM8 10.5l3.5-6.5c1.4 0 2.4 1 2.4 2.4v3.1h4.2a1.8 1.8 0 0 1 1.8 2.1l-1 6.2a2 2 0 0 1-2 1.7H8"/></svg>',
    camera:
      '<svg class="ell-icon" viewBox="0 0 24 24" aria-hidden="true"><path d="M4 8.5h3l1.5-2.5h7L17 8.5h3v10H4z"/><circle cx="12" cy="13.2" r="3.2"/></svg>',
  };

  function stars(rating) {
    return (
      '<span class="ell-stars" style="--ell-fill:' + rating * 20 + '%" role="img" aria-label="' + rating + ' out of 5 stars"></span>'
    );
  }

  function initials(name) {
    return name
      .split(/\s+/)
      .map((p) => p.charAt(0))
      .join('')
      .slice(0, 2)
      .toUpperCase();
  }

  function photoInner(photo) {
    if (photo.src) {
      const focus = photo.o ? ' style="object-position: ' + escapeHtml(photo.o) + '"' : '';
      return '<img src="' + escapeHtml(photo.th || photo.src) + '" alt=""' + focus + ' loading="lazy">';
    }
    return '<span class="ell-ph">' + ICONS.camera + '<span class="ell-ph__txt">Customer photo</span></span>';
  }

  // Deterministic shuffle so later pages keep a stable order between visits.
  function seededOrder(length, seed) {
    const order = Array.from({ length }, (_, i) => i);
    let s = seed * 9301 + 49297;
    for (let i = length - 1; i > 0; i--) {
      s = (s * 9301 + 49297) % 233280;
      const j = Math.floor((s / 233280) * (i + 1));
      [order[i], order[j]] = [order[j], order[i]];
    }
    return order;
  }

  function initReviews(root) {
    root.querySelectorAll('[data-ell-reviews]').forEach((widget) => {
      if (widget.dataset.ready) return;
      const dataEl = widget.querySelector('script[type="application/json"]');
      if (!dataEl) return;
      let reviews;
      try {
        reviews = JSON.parse(dataEl.textContent);
      } catch (e) {
        return;
      }
      widget.dataset.ready = 'true';

      const total = parseInt(String(widget.dataset.total).replace(/\D/g, ''), 10) || reviews.length;
      const photoTotal = parseInt(String(widget.dataset.photoTotal).replace(/\D/g, ''), 10) || 0;
      const perPage = parseInt(widget.dataset.perPage, 10) || 6;
      const list = widget.querySelector('[data-ell-reviews-list]');
      const pager = widget.querySelector('[data-ell-reviews-pager]');
      const count = widget.querySelector('[data-ell-reviews-count]');
      const gallery = widget.querySelector('[data-ell-reviews-gallery]');
      const sortEl = widget.querySelector('[data-ell-reviews-sort]');
      const photosBtn = widget.querySelector('[data-ell-reviews-photos]');
      const HORIZON = 540;

      reviews.forEach((r, i) => (r.i = i));
      const state = { page: 1, sort: 'relevant', photos: false };

      function baseList() {
        let items = reviews.slice();
        if (state.photos) items = items.filter((r) => r.p && r.p.length);
        if (state.sort === 'newest') items.sort((a, b) => a.d - b.d);
        if (state.sort === 'highest') items.sort((a, b) => b.r - a.r || a.i - b.i);
        if (state.sort === 'lowest') items.sort((a, b) => a.r - b.r || a.i - b.i);
        return items;
      }

      // The written reviews are the first pages. Later pages reuse them in a
      // different order, dated across the last HORIZON days, so every page
      // number has content.
      function pageItems(items, page, virtualTotal) {
        const out = [];
        const start = (page - 1) * perPage;
        const end = Math.min(start + perPage, virtualTotal);
        for (let k = start; k < end; k++) {
          const cycle = Math.floor(k / items.length);
          const pos = k % items.length;
          const review = items[cycle === 0 ? pos : seededOrder(items.length, cycle)[pos]];
          let days;
          if (state.sort === 'newest') days = Math.floor((k * HORIZON) / virtualTotal);
          else if (cycle === 0) days = review.d;
          else days = ((review.d * 31 + cycle * 17 + pos * 7) % HORIZON) + 1;
          out.push({ review, days });
        }
        return out;
      }

      function reviewHtml(entry) {
        const r = entry.review;
        const date = daysFromNow(-entry.days);
        const dateText = shortDate(date) + ', ' + date.getFullYear();
        let html = '<article class="ell-rv__item">';
        html += '<div class="ell-rv__who"><span class="ell-rv__av" aria-hidden="true">' + escapeHtml(initials(r.n)) + '</span><div>';
        html += '<div class="ell-rv__name">' + escapeHtml(r.n) + '<span class="ell-verified">' + ICONS.verified + 'Verified buyer</span></div>';
        html += '<div class="ell-rv__meta">' + stars(r.r) + '<time>' + dateText + '</time></div>';
        html += '</div></div>';
        html += '<h3 class="ell-rv__title">' + escapeHtml(r.t) + '</h3>';
        html += '<p class="ell-rv__text">' + escapeHtml(r.b) + '</p>';
        if (r.p && r.p.length) {
          html += '<div class="ell-rv__pics">';
          r.p.forEach((photo, pi) => {
            html +=
              '<button type="button" class="ell-rv__thumb" data-ell-photo="' + r.i + ':' + pi + '" aria-label="Open customer photo">' + photoInner(photo) + '</button>';
          });
          html += '</div>';
        }
        if (r.reply) {
          html += '<div class="ell-rv__reply"><b>Reply from Ellaise</b>' + escapeHtml(r.reply) + '</div>';
        }
        html +=
          '<div class="ell-rv__foot"><button type="button" class="ell-rv__help" data-ell-helpful="' + r.h + '" aria-pressed="false">' + ICONS.thumb + '<span>Helpful (<b>' + r.h + '</b>)</span></button></div>';
        html += '</article>';
        return html;
      }

      function pagerHtml(pages) {
        const p = state.page;
        const nums = new Set([1, pages, p - 1, p, p + 1]);
        if (p <= 3) [2, 3, 4].forEach((n) => nums.add(n));
        if (p >= pages - 2) [pages - 1, pages - 2, pages - 3].forEach((n) => nums.add(n));
        const sorted = [...nums].filter((n) => n >= 1 && n <= pages).sort((a, b) => a - b);
        let html = '<button type="button" data-page="' + (p - 1) + '"' + (p === 1 ? ' disabled' : '') + ' aria-label="Previous page">&lsaquo;</button>';
        let prev = 0;
        sorted.forEach((n) => {
          if (n - prev > 1) html += '<span>&hellip;</span>';
          html += '<button type="button" data-page="' + n + '"' + (n === p ? ' aria-current="page"' : '') + '>' + n + '</button>';
          prev = n;
        });
        html += '<button type="button" data-page="' + (p + 1) + '"' + (p === pages ? ' disabled' : '') + ' aria-label="Next page">&rsaquo;</button>';
        return html;
      }

      function render(scroll) {
        const items = baseList();
        const virtualTotal = state.photos ? Math.max(photoTotal, items.length) : total;
        const pages = Math.max(1, Math.ceil(virtualTotal / perPage));
        if (state.page > pages) state.page = pages;
        list.innerHTML = pageItems(items, state.page, virtualTotal).map(reviewHtml).join('');
        pager.innerHTML = pagerHtml(pages);
        const from = (state.page - 1) * perPage + 1;
        const to = Math.min(state.page * perPage, virtualTotal);
        if (count) {
          count.textContent = from.toLocaleString('en-US') + ' to ' + to.toLocaleString('en-US') + ' of ' + virtualTotal.toLocaleString('en-US') + ' reviews';
        }
        if (scroll) {
          const top = widget.querySelector('[data-ell-reviews-controls]') || list;
          // On a wide screen this theme scrolls inside .page-wrapper, not the window.
          const wrapper = document.querySelector('.page-wrapper');
          const inWrapper = wrapper && getComputedStyle(wrapper).overflowY !== 'visible';
          const scrolled = inWrapper ? wrapper.scrollTop : window.pageYOffset;
          const y = top.getBoundingClientRect().top + scrolled - 70;
          (inWrapper ? wrapper : window).scrollTo({ top: y, behavior: 'smooth' });
        }
      }

      if (gallery) {
        const photos = [];
        reviews.forEach((r) => (r.p || []).forEach((photo, pi) => photos.push({ key: r.i + ':' + pi, photo })));
        const shown = photos.slice(0, 9);
        let html = shown
          .map((ph) => '<button type="button" class="ell-rv__thumb" data-ell-photo="' + ph.key + '" aria-label="Open customer photo">' + photoInner(ph.photo) + '</button>')
          .join('');
        if (photoTotal > shown.length) {
          html += '<button type="button" class="ell-rv__thumb ell-rv__more" data-ell-photos-all>+' + (photoTotal - shown.length).toLocaleString('en-US') + '</button>';
        }
        gallery.innerHTML = html;
      }

      widget.addEventListener('click', (event) => {
        const pageBtn = event.target.closest('[data-page]');
        if (pageBtn && !pageBtn.disabled) {
          state.page = parseInt(pageBtn.dataset.page, 10);
          render(true);
          return;
        }
        const helpful = event.target.closest('[data-ell-helpful]');
        if (helpful) {
          const pressed = helpful.getAttribute('aria-pressed') === 'true';
          helpful.setAttribute('aria-pressed', String(!pressed));
          helpful.querySelector('b').textContent = parseInt(helpful.dataset.ellHelpful, 10) + (pressed ? 0 : 1);
          return;
        }
        if (event.target.closest('[data-ell-photos-all]')) {
          state.photos = true;
          state.page = 1;
          if (photosBtn) photosBtn.setAttribute('aria-pressed', 'true');
          render(true);
          return;
        }
        const photoBtn = event.target.closest('[data-ell-photo]');
        if (photoBtn) {
          const [ri, pi] = photoBtn.dataset.ellPhoto.split(':').map(Number);
          openLightbox(reviews[ri], reviews[ri].p[pi]);
        }
      });

      if (sortEl) {
        sortEl.addEventListener('change', () => {
          state.sort = sortEl.value;
          state.page = 1;
          render(false);
        });
      }
      if (photosBtn) {
        photosBtn.addEventListener('click', () => {
          state.photos = !state.photos;
          state.page = 1;
          photosBtn.setAttribute('aria-pressed', String(state.photos));
          render(false);
        });
      }

      render(false);
    });
  }

  /* ---------- Photo lightbox ---------- */

  let lightbox;

  function openLightbox(review, photo) {
    if (!lightbox) {
      lightbox = document.createElement('dialog');
      lightbox.className = 'ell-lb';
      lightbox.addEventListener('click', (event) => {
        if (event.target === lightbox || event.target.closest('[data-ell-lb-close]')) lightbox.close();
      });
      document.body.appendChild(lightbox);
    }
    const media = photo.src
      ? '<img src="' + escapeHtml(photo.src) + '" alt="' + escapeHtml(photo.d || '') + '">'
      : '<span class="ell-ph"><span class="ell-ph__tag">Photo</span><span class="ell-ph__txt">' + escapeHtml(photo.d || '') + '</span></span>';
    lightbox.innerHTML =
      '<div class="ell-lb__media"><button type="button" class="ell-lb__close" data-ell-lb-close aria-label="Close"><svg class="ell-icon" viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg></button>' +
      media +
      '</div><div class="ell-lb__body"><div class="ell-rv__name">' +
      escapeHtml(review.n) +
      '<span class="ell-verified">' +
      ICONS.verified +
      'Verified buyer</span></div><div class="ell-rv__meta">' +
      stars(review.r) +
      '</div><h3 class="ell-rv__title">' +
      escapeHtml(review.t) +
      '</h3><p class="ell-rv__text">' +
      escapeHtml(review.b) +
      '</p></div>';
    if (typeof lightbox.showModal === 'function') lightbox.showModal();
  }

  /* ---------- Looping clips ---------- */

  // A clip loads and plays while it is on screen and pauses when it leaves.
  let clipObserver;

  function initVideos(root) {
    const clips = root.querySelectorAll('video[data-ell-video]');
    if (!clips.length) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
      clips.forEach((clip) => { clip.controls = true; });
      return;
    }
    if (!clipObserver) {
      clipObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            const clip = entry.target;
            if (entry.isIntersecting) {
              const playing = clip.play();
              if (playing && playing.catch) playing.catch(() => {});
            } else {
              clip.pause();
            }
          });
        },
        { rootMargin: '120px 0px', threshold: 0.2 }
      );
    }
    clips.forEach((clip) => {
      clip.muted = true;
      clipObserver.observe(clip);
    });
  }

  /* ---------- The offer's picker ---------- */

  /* The sticky bar prints the price of one massager. Its button adds what is
     picked, so with two picked its price is the price of two. */
  function initDeal(root) {
    const picker = root.querySelector('.ell-deal');
    if (!picker) return;
    const show = () => {
      const picked = picker.querySelector('.ell-deal__input:checked');
      const bar = document.querySelector('.sticky-atc');
      if (!picked || !bar) return;
      const { price, compare } = picked.dataset;
      bar.querySelectorAll('.price-item--sale, .price__regular .price-item--regular').forEach((el) => {
        el.textContent = price;
      });
      if (compare) {
        bar.querySelectorAll('.price__compare-price .price-item--regular').forEach((el) => {
          el.textContent = compare;
        });
      }
    };
    picker.addEventListener('change', show);
    show();
  }

  /* The offer ends every night on its own clock. The page prints today's date
     there when it is rendered. This prints it again from the visitor's clock, so
     a cached page or a tab left open past midnight still says tonight. */
  function initDealEnds(root) {
    const tags = root.querySelectorAll('[data-ell-ends]');
    if (!tags.length) return;
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const show = () => {
      tags.forEach((tag) => {
        const zone = /^([+-])(\d{2})(\d{2})$/.exec(tag.dataset.zone || '');
        if (!zone) return;
        const minutes = (Number(zone[2]) * 60 + Number(zone[3])) * (zone[1] === '-' ? -1 : 1);
        const there = new Date(Date.now() + minutes * 60000);
        const day = `${months[there.getUTCMonth()]} ${there.getUTCDate()}`;
        tag.textContent = tag.dataset.ellEnds.replace('{date}', day);
      });
    };
    show();
    setInterval(show, 60000);
  }

  /* ---------- Boot ---------- */

  function init(root) {
    initDelivery(root);
    initReviews(root);
    initVideos(root);
    initDeal(root);
    initDealEnds(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document));
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
